import { memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getAuth, signOut } from 'firebase/auth'
import { isEmpty } from 'lodash'

import {
  AUTH_KEYCLOAK_SUCCESS,
  GET_CONTINUE_WATCHING_SUCCESS,
  GET_NOT_VIEWED_CONTINUE_WATCHING_SUCCESS,
  GET_PROFILE_PREFERENCES_SUCCESS,
  GET_SERIE_SUCCESS,
  SET_CURRENT_PROFILE,
  GET_PLAN,
  CANCEL_SUBSCRIPTION,
  AUTH_KEYCLOAK_ERROR
} from '../../redux/actions'

import ProfileContainer from '../../containers/profile/ProfileContainer'
import Loading from '../Loading'
import { getKeycloakUserInfo } from '../../utils/tokenStorage'
import { logoutKeycloak } from '../../utils/logout'

export default memo(function ProfileComponent() {
  const { isAuthenticated, keycloak, firebaseConfigs: { useImageCDN } } = useSelector(state => state.auth)
  const { planById: plan, isLoadingById } = useSelector(state => state.plans)
  const { data: subscription, isLoading, isLoadingCancel, subscriber } = useSelector(state => state.subscription)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    !isAuthenticated && !isEmpty(keycloak) && keycloak.login()
  }, [isAuthenticated, keycloak])

  useEffect(() => {
    !isEmpty(keycloak) && !isEmpty(subscription) && isEmpty(plan)
      && dispatch(GET_PLAN({ keycloak, id: subscription.plan_id }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak, subscription, plan])

  const handleOnCancelSubscription = () => {
    let caducado = subscription.subscription_end &&
      subscription.subscription_end >= new Date()
    if (subscription.paid && !caducado) {
      dispatch(CANCEL_SUBSCRIPTION({
        keycloak,
        subscription_id: subscription.id,
        subscriptor_id: subscription.subscriber_id,
        url_callback: window.location.origin
      }))
    } else {
      navigate('/planes')
    }
  }

  const logout = async () => {
    const auth = getAuth()
    try {
      await logoutKeycloak();
      dispatch(AUTH_KEYCLOAK_SUCCESS({ keycloak: null, isAuthenticated: false, idUser: '', email: '' }))
      navigate('/');
      signOut(auth)
      window.location.reload();
    } catch (err) {
      dispatch(AUTH_KEYCLOAK_ERROR({error: err.message}))
    }
  }

  const handleOnSelectProfile = profile => {
    const localProfile = { currentProfileId: profile.id, timestamp: new Date().getTime() }
    localStorage.setItem('currentProfile', JSON.stringify(localProfile))
    dispatch(SET_CURRENT_PROFILE(profile))
    dispatch(GET_PROFILE_PREFERENCES_SUCCESS([]))
    dispatch(GET_CONTINUE_WATCHING_SUCCESS([]))
    dispatch(GET_NOT_VIEWED_CONTINUE_WATCHING_SUCCESS([]))
    dispatch(GET_SERIE_SUCCESS({}))
  }

  useEffect(() => {
    document.title = 'Mega GO | Cuenta'
    return () => {
      document.title = 'Mega GO'
    }
  }, [])

  // userInfo desde tokenStorage
  const userData = getKeycloakUserInfo() || {}

  return (
    isLoading || (isLoadingById && !isEmpty(subscription)) || isLoadingCancel
      ? <Loading />
      :
      <ProfileContainer
        handleOnCancelSubscription={handleOnCancelSubscription}
        handleOnSelectProfile={handleOnSelectProfile}
        navigate={navigate}
        logout={logout}
        plan={plan}
        subscriber={subscriber}
        status={subscription?.status || ''}
        userData={userData}
        useImageCDN={useImageCDN}
      />
  )
})